import { Outlet, Route, Routes } from "react-router-dom";
import { Link } from "react-router-dom";

import { AuthProvider } from "./AuthContext";
import { AppShell } from "../components/AppShell";
import { Toaster } from "../components/ui/sonner";
import { Button } from "../components/ui/button";
import { LoginPage } from "../pages/LoginPage";
import { ProjectsHomePage } from "../pages/ProjectsHomePage";
import { NewProjectPage } from "../pages/NewProjectPage";
import { ProjectOverviewPage } from "../pages/ProjectOverviewPage";
import { ProjectReportsPage } from "../pages/ProjectReportsPage";
import { ProjectApiKeysPage } from "../pages/ProjectApiKeysPage";
import { ProjectReportDetailPage } from "../pages/ProjectReportDetailPage";
import { ProjectWebhooksPage } from "../pages/ProjectWebhooksPage";
import { SettingsMcpPage } from "../pages/SettingsMcpPage";
import {
  Page,
  PageBody,
  PageHeader,
  PageTitle,
  PageDescription,
} from "../components/PageLayout";

export function App() {
  return (
    <AuthProvider>
      <AppShell>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<Outlet />}>
            <Route index element={<ProjectsHomePage />} />
            <Route path="projects/new" element={<NewProjectPage />} />
            <Route path="projects/:id" element={<ProjectOverviewPage />} />
            <Route path="projects/:id/reports" element={<ProjectReportsPage />} />
            <Route
              path="projects/:id/reports/:reportId"
              element={<ProjectReportDetailPage />}
            />
            <Route
              path="projects/:id/api-keys"
              element={<ProjectApiKeysPage />}
            />
            <Route
              path="projects/:id/webhooks"
              element={<ProjectWebhooksPage />}
            />
            <Route path="settings/mcp" element={<SettingsMcpPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </AppShell>
      <Toaster />
    </AuthProvider>
  );
}

function NotFound() {
  return (
    <Page>
      <PageHeader>
        <PageTitle>Not found</PageTitle>
        <PageDescription>
          The page you requested does not exist or has been moved.
        </PageDescription>
      </PageHeader>
      <PageBody width="narrow">
        <div className="flex flex-col items-start gap-3 rounded-xl border border-dashed border-border bg-card/60 p-6">
          <div className="font-mono text-3xl font-semibold tracking-tight text-muted-foreground">
            404
          </div>
          <p className="text-sm text-muted-foreground">
            No route matched the requested URL.
          </p>
          <Button render={<Link to="/" />} nativeButton={false} variant="outline" size="sm">
            Back to projects
          </Button>
        </div>
      </PageBody>
    </Page>
  );
}
